module.exports = __webpack_public_path__ + "static/img/pumpsoftwhite.10c927b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pumpsoftwhite.png
// module id = TOtK
// module chunks = 1